import { render, staticRenderFns } from "./exchange-code-create.vue?vue&type=template&id=18d79a6b&scoped=true"
import script from "./exchange-code-create.vue?vue&type=script&lang=ts"
export * from "./exchange-code-create.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d79a6b",
  null
  
)

export default component.exports